import React, { useState } from "react";
import { Button, message } from "antd";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";

import useApplications from "hooks/applications/useApplications";
import ApplicationsTable from "./ApplicationsTable";
import ApplicationDrawer from "./ApplicationsDrawer";
import ApplicationSecretsDrawer from "./ApplicationSecretsDrawer";
import { PlusOutlined } from "@ant-design/icons";

export default function ApplicationsPage() {
  const {
    applications,
    loading,
    createApplication,
    updateApplication,
    deleteApplication,
    generatePrimarySecret,
    rotateSecret,
    revokeSecondarySecret
  } = useApplications();

  const [editingApp, setEditingApp] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [secretsDrawerVisible, setSecretsDrawerVisible] = useState(false);
  const [selectedAppForSecrets, setSelectedAppForSecrets] = useState(null);

  const openDrawer = (app = null) => {
    setEditingApp(app);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setEditingApp(null);
    setDrawerVisible(false);
  };

  const handleSubmit = async (payload) => {
    try {
      setSubmitting(true);

      if (editingApp) {
        const updated = await updateApplication(editingApp.id, payload);
        if (updated) {
          closeDrawer();
        }
      } else {
        const created = await createApplication(payload);
        if (created) {
          closeDrawer();
        }
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteApplication(id);
      message.success("Application deleted");
    } catch (err) {
      message.error("Failed to delete application");
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon={["fab", "adn"]}
          title="Oliveeb Applications"
          subtitle="Manage all Oliveeb applications and services"
          transform="shrink-2"
          className="flex-1"
        />

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => openDrawer()}
          style={{ marginBottom: 16 }}
        >
          New Application
        </Button>
      </div>

      <ApplicationsTable
        applications={applications}
        loading={loading}
        onEdit={openDrawer}
        onDelete={handleDelete}
        // onToggleActive={handleToggle}
        onManageSecrets={(app) => {
          setSelectedAppForSecrets(app);
          setSecretsDrawerVisible(true);
        }}
      />

      <ApplicationDrawer
        visible={drawerVisible}
        onClose={closeDrawer}
        onSubmit={handleSubmit}
        application={editingApp}
        loading={submitting}
      />

      <ApplicationSecretsDrawer
        visible={secretsDrawerVisible}
        onClose={() => setSecretsDrawerVisible(false)}
        application={selectedAppForSecrets}
        loading={loading}
        generatePrimarySecret={generatePrimarySecret}
        rotateSecret={rotateSecret}
        revokeSecondarySecret={revokeSecondarySecret}
      />
    </>
  );
}
